import { useState, useEffect, useCallback } from 'react'
import { getSPDataWithParams } from 'src/supportPortal/services/services'
import { getDataMapFromCommonResponse, isCommonResponseSuccessfulV2 } from 'src/mentor/helpers/utilityFunctions'

export const useFollowupJourney = (bookedEventId, actionTrack, enabled = true) => {
  const [journey, setJourney] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const fetchJourney = useCallback(async () => {
    if (!enabled || !bookedEventId || !actionTrack) {
      setJourney(null)
      return
    }

    setLoading(true)
    setError(null)

    try {
      const params = {
        bookedEventId,
        actionTrack,
      }

      const response = await getSPDataWithParams('/api/secure/cc/support/followups/journey', params)

      if (response.status === 200 && isCommonResponseSuccessfulV2(response)) {
        const data = getDataMapFromCommonResponse(response)?.['support-followup-journey']
        setJourney(data)
      } else {
        setError('Failed to fetch journey')
        setJourney(null)
      }
    } catch (err) {
      console.error('Error fetching journey:', err)
      setError('An error occurred while fetching journey')
      setJourney(null)
    } finally {
      setLoading(false)
    }
  }, [bookedEventId, actionTrack, enabled])

  useEffect(() => {
    fetchJourney()
  }, [fetchJourney])

  return {
    journey,
    loading,
    error,
    refreshJourney: fetchJourney,
  }
}


